import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { useTheme } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';

import * as api from '_core/utils/api';
import { useVisitorInfo } from '_core/utils/visitorInfo';
import { useGlobal } from '_core/hooks/useGlobal';

import { DeliveryWidget } from './DeliveryWidget';


const RawCartStepsDeliveryWidget = (props) => {
  const history = useHistory();
  
  const {
    config: { ROUTE_URL }
  } = useGlobal();
  
  const theme = useTheme();
  
  const visitorInfo = useVisitorInfo();
  
  
  const returnPath = ROUTE_URL.CART;
  const errorPath = returnPath;
  const paymentPath = returnPath + '/payment';
  
  return (
    <DeliveryWidget
      type="delivery"
      visitorGroup={visitorInfo.info?.visitor_group}
      
      onNextPage={(order) => history.push(paymentPath + '/' + order.id.join(','))}
      onPrevPage={(error) => {
        if (error?.code === 'data-wrong') {
          //setGoodsState((state) => ({ ...state, goodsRest: {} }));
          
          if (errorPath) {
            history.push(errorPath);
          } else if (returnPath) {
            history.push(returnPath);
          } else {
            history.push('/');
          }
        } else {
          if (returnPath) {
            history.push(returnPath);
          } else if (errorPath) {
            history.push(errorPath);
          } else {
            history.push('/');
          }
        }
      }}
    />
  );
};

RawCartStepsDeliveryWidget.defaultProps = {};

RawCartStepsDeliveryWidget.propTypes = {
  setResult: PropTypes.func.isRequired
};

export const CartStepsDeliveryWidget = RawCartStepsDeliveryWidget;
